// Batch 11 · B2 — the one table of "which URL parameter opens which head-folder worksheet dialog". The Head Folders page,
// the forms list dialog and every worksheet dialog read it, so a link can no longer name a parameter no dialog reads
// (the forms list sent "openRpt" while the related-party dialog read "openRp").
export const WS_OPEN_PARAM = {
  completeness: "openComp",
  inventory_count: "openInv",
  estimate: "openEst",
  related_party: "openRp",
};
export const WS_OPEN_DEFAULT = "open";      // aging, cut-off and the other HeadFolderWorksheetDialog worksheets

export const wsOpenParam = (kind) => WS_OPEN_PARAM[kind] || WS_OPEN_DEFAULT;

export const wsHref = (kind, ref) => `/head-folders?${wsOpenParam(kind)}=${encodeURIComponent(ref)}`;

// Step 11d-3 · Mars find 4: the five fixed head-folder worksheets HeadFolderWorksheetDialog opens (backend
// routes_fieldwork_heads._HFW_CODES). Any other "<head>-06" / "<head>-07" in ?open= is a folder SLOT ("06 Forms / Worksheets",
// "07 …"): it opens that slot's forms list, never a worksheet dialog under the wrong title.
export const STATIC_WS_CODES = ["1203-06", "3203-06", "4101-06", "5101-06", "1201-07"];
// Batch 26 · Add-on 1: a liability head's -07 is the unrecorded-liabilities worksheet (SurlWorksheetDialog) — moved here from that file
export const SURL_CODE_RX = /^3(10[1-8]|20[1-9]|21[0-2])-07$/;
const SLOT_RX = /^(\d{4})-(0[67])$/;

/** {fs_code, file_id} when ?open=<code> names a folder slot rather than a fixed worksheet or the unrecorded-liabilities worksheet
 *  (<liability head>-07, SurlWorksheetDialog); otherwise null. */
export function openSlotOf(code) {
  const m = SLOT_RX.exec(String(code || ""));
  if (!m || STATIC_WS_CODES.includes(code) || SURL_CODE_RX.test(code)) return null;
  return { fs_code: m[1], file_id: m[2] };
}
